import React, { useState, useRef } from "react";

const pad = (num) => String(num).padStart(2, "0");

const TimeInput = ({ name, value, onChange, placeholder }) => {
    

  const inputRef = useRef(null);
  const [time, setTime] = useState(() => {
    const [h = "0", m = "0", s = "0"] = (value || "00:00:00").split(":");
    return { hours: +h, minutes: +m, seconds: +s };
  });
  const [activeSegment, setActiveSegment] = useState("hours");

  const segmentMap = {
    hours: [0, 2],
    minutes: [3, 5],
    seconds: [6, 8],
  };

  const moveCaretToSegment = (segment) => {
    const input = inputRef.current;
    if (!input) return;
    const [start, end] = segmentMap[segment];
    input.setSelectionRange(start, end);
    setActiveSegment(segment);
  };

  const getSegmentFromPosition = (pos) => {
    if (pos < 3) return "hours";
    if (pos < 6) return "minutes";
    return "seconds";
  };

  const updateTimeSegment = (segment, val) => {
    const newTime = { ...time, [segment]: val };
    setTime(newTime);
    const newValue = `${pad(newTime.hours)}:${pad(newTime.minutes)}:${pad(
      newTime.seconds
    )}`;
    onChange({ target: { name, value: newValue } }); // sync with formData
    setTimeout(() => moveCaretToSegment(segment), 0);
  };

  const handleClick = (e) => {
    const pos = e.target.selectionStart;
    const segment = getSegmentFromPosition(pos);
    setActiveSegment(segment);
    moveCaretToSegment(segment);
  };

  const handleKeyDown = (e) => {
    const segment = activeSegment;
    let val = time[segment];

    if (e.key === "ArrowUp") {
      val = (val + 1) % (segment === "hours" ? 24 : 60);
      updateTimeSegment(segment, val);
      e.preventDefault();
    } else if (e.key === "ArrowDown") {
      val = (val - 1 + (segment === "hours" ? 24 : 60)) % (segment === "hours" ? 24 : 60);
      updateTimeSegment(segment, val);
      e.preventDefault();
    } else if (e.key === "ArrowLeft") {
      const newSegment = segment === "minutes" ? "hours" : "minutes";
      setActiveSegment(newSegment);
      setTimeout(() => moveCaretToSegment(newSegment), 0);
    } else if (e.key === "ArrowRight") {
      const newSegment = segment === "hours" ? "minutes" : "seconds";
      setActiveSegment(newSegment);
      setTimeout(() => moveCaretToSegment(newSegment), 0);
    }
  };

  const handleBlur = () => {
    const [h = "0", m = "0", s = "0"] = (value || "00:00:00").split(":");
    const parsed = {
      hours: Math.min(23, parseInt(h, 10) || 0),
      minutes: Math.min(59, parseInt(m, 10) || 0),
      seconds: Math.min(59, parseInt(s, 10) || 0),
    };
    const fixedValue = `${pad(parsed.hours)}:${pad(parsed.minutes)}:${pad(parsed.seconds)}`;
    setTime(parsed);
    onChange({ target: { name, value: fixedValue } });
  };

  return (
    <input
      ref={inputRef}
      name={name}
      value={value || "00:00:00"}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      onChange={(e) => onChange(e)} // still allows typing
      onBlur={handleBlur}
      maxLength={8}
      placeholder={placeholder || "HH:MM:SS"}
      style={{ width: "150px" }}
    />
  );
};

export default TimeInput;
